import React, { Component, Fragment } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import NgGameRPGArenaUiExtras from './extras';
import NgGameRPGArenaUiCave from './cave';
import { setStrikes, BASE_STRIKES, TECHNICS } from '../utils/technics';
import { isEmpty } from 'lodash';
import './uistyle.css';

export default class NgGameRPGArenaUi extends Component {

    state = {
        phase: 'nophase',
        moveType: 'none', // defence strike
        multyType: false, // режим для комбо
        multyTypeCombo: [],
        technics: {} // strike: [], defence: []
    }

    componentDidMount = () => {
        document.addEventListener("keypress", this.keyPressed);
    }
    componentWillUnmount = () => {
        document.removeEventListener("keypress", this.keyPressed);
    }
    keyPressed = (e) => {
        const { key: code } = e;
        const { phase, technics, moveType } = this.state;
        if (phase !== 'ui') return;
        const techToMap = technics[moveType] || []
        let tech = null;
        if (((code === 'y') || (code === 'Y')) && !!techToMap.length && techToMap.length > 0 && techToMap[0]) tech = techToMap[0]
        if (((code === 'u') || (code === 'U')) && !!techToMap.length && techToMap.length > 1 && techToMap[1]) tech = techToMap[1]
        if (((code === 'i') || (code === 'I')) && !!techToMap.length && techToMap.length > 2 && techToMap[2]) tech = techToMap[2]
        if (((code === 'o') || (code === 'O')) && !!techToMap.length && techToMap.length > 3 && techToMap[3]) tech = techToMap[3]
        if (((code === 'p') || (code === 'P')) && !!techToMap.length && techToMap.length > 4 && techToMap[4]) tech = techToMap[4]

        if (tech && TECHNICS[tech]) {
            const index = techToMap.indexOf(tech);
            this.onUiClickHandler({ point: TECHNICS[tech].point, type: TECHNICS[tech].type, technics: tech }, index)
        }
    }

    refExtras = React.createRef();

    initUiFromAllEngine = ({ onStartClick, onBlockClicked, onUiClick, setPlayerBuff, onUiCheck, getMoveStats, setPlayerExtras, abandoneCave }) => {
        this.onStartClick = (props) => onStartClick(props);
        this.onBlockClicked = (props) => onBlockClicked(props);
        this.onUiClick = (props) => onUiClick(props);
        this.onUiCheck = props => onUiCheck(props);
        this.setPlayerBuff = props => setPlayerBuff(props);
        this.getMoveStats = () => getMoveStats();
        this.setPlayerExtras = (props) => setPlayerExtras(props);
        this.abandoneCave = (props) => abandoneCave(props)
    }

    onUiClickHandler = (props, usedStrikeNumber) => {

        const { type } = props;
        if (type === 'strike') {
            const strike = setStrikes({ allreadyStrikes: this.state.technics.strike, allStrikes: this.allStrikes, usedStrikeNumber })
            this.setState({ technics: { ...this.state.technics, strike } })
        }

        this.onUiClick(props);
    }

    setPhase = (phase) => {
        // в начале фазы убираем мульти
        this.setState({ phase, multyType: false, multyTypeCombo: [] })
        console.log(`### UI установил фазу ${phase}`)
    }
    setCheck = () => {
        this.onUiCheck();
    }

    setMoveProps = ({ whosTurn, player, noNewMove }) => {
        const { race } = whosTurn;
        // const { technics } = player;

        if (race === 'ai') {
            this.setDefenceTechics(player);
        } else {
            this.setStrikeTechics();
        }

        const moveStats = this.getMoveStats();
        this.refExtras.current && this.refExtras.current.newMove(moveStats, noNewMove);
    }

    setDefenceTechics = (player) => {

        let newState = {};
        const { buffs } = player;

        if (buffs && buffs.length && buffs.find(x => x.type === 'sbiv')) {
            newState.moveType = 'strike';
        }
        if (buffs && buffs.length && buffs.find(x => x.type === 'contra')) {
            newState.moveType = 'strike';
            newState.multyType = true;
        }
        if (!isEmpty(newState)) {
            this.setState(newState);
            return;
        }

        const defence = this.returnDefenceByBuf(player);
        this.setState({ moveType: 'defence', multyType: false, multyTypeCombo: [], technics: { ...this.state.technics, defence } })
    }
    setStrikeTechics = () => {
        this.setState({ moveType: 'strike' })
    }

    // const allStrikes = ['martelo', 'armada', 'compassa', 'bencao', 'rasteira'];
    // let res = setStrikes({ allreadyStrikes: ['martelo', 'bencao', 'rasteira', null], allStrikes, usedStrikeNumber: 3 })

    setCharTechnics = ({ technics, strikesCount }) => {
        this.allStrikes = technics.strike.map(({ key }) => key);
        this.allDefences = technics.defence.map(({ key }) => key);
        this.strikesCount = strikesCount;

        // нужно сразу добрать удары
        let allreadyStrikes = [...BASE_STRIKES];
        for (let i = 3; i < strikesCount; i++) {
            allreadyStrikes.push(null);
        }

        let usedStrikeNumber = 3;
        while (usedStrikeNumber < strikesCount) {
            allreadyStrikes = setStrikes({ allreadyStrikes, allStrikes: this.allStrikes, usedStrikeNumber })
            usedStrikeNumber++;
        }

        let technicsToState = {};
        technicsToState.strike = [...allreadyStrikes];
        technicsToState.defence = [...this.allDefences];
        this.setState({ technics: technicsToState })
    }

    returnDefenceByBuf = ({ buffs = [] }) => {
        const defenceKeys = this.allDefences.reduce((memo, key) => {
            const tech = TECHNICS[key];
            if (tech.noBuff) {
                for (let i = 0; i < tech.noBuff.length; i++) {
                    const buf = tech.noBuff[i];
                    if (buffs.find(x => x.type === buf)) {
                        return memo;
                    }
                }
            }
            if (tech.yesBuff) {
                for (let i = 0; i < tech.yesBuff.length; i++) {
                    const buf = tech.yesBuff[i];
                    if (!buffs.find(x => x.type === buf)) {
                        return memo;
                    }
                }
            }

            return [...memo, key];

        }, [])

        return defenceKeys;
    }

    setCharExtrasInner = (props) => {
        console.log('setCharExtrasInner');
        this.refExtras.current && this.refExtras.current.setCharExtrasInner(props);
    }

    extrasInner = () => {
        const moveStats = this.getMoveStats();
        const {
            Pers1: { extras, extrasSlots }
        } = moveStats;
        return { extras, extrasSlots };
    }

    getExtraSlots = () => {
        return (this.refExtras.current && this.refExtras.current.getSlots()) || []
    }
    

    setCaveSession = (caveSession) => {
        this.setState({ caveSession });
    }

    onBlockClick = (id) => {
        this.onBlockClicked(id);
    }
    onCaveNextClick = () => {
        this.setState({ phase: 'cavescreen' })
    }

    render() {

        const { phase, caveSession } = this.state;
        const { arena } = this.props;
        const { width: arenaWidth, height: arenaHeight } = arena;

        if (phase === 'cavescreen' || phase === 'endCaveScreen') {
            return <NgGameRPGArenaUiCave
                onBlockClick={this.onBlockClick}
                onNextClick={this.onCaveNextClick}
                setPlayerExtras={this.setPlayerExtras}
                abandoneCave={this.abandoneCave}
                phase={phase}
                caveSession={caveSession}
                arena={{ arenaWidth, arenaHeight }}
                width={arenaWidth * 0.9}
                height={arenaWidth * 0.5}
            />
        }

        if (phase === 'startscreen__') {
            return <div className='ngg_arena_ui_btn_start' style={{ left: arenaWidth / 2, top: arenaHeight * 0.25 }} onClick={this.onStartClick}>
                <span>
                    НАЧАТЬ
                </span>
            </div>

        }

        if (phase === 'ui' || phase === 'none') {

            const uiTechWidth = arenaWidth * 0.3;
            const uiTechHeight = arenaHeight * 0.15;

            const uiCardWidth = uiTechWidth * 0.2;
            const uiCardHeight = uiTechHeight * 0.8;

            const { technics, moveType } = this.state;

            const techToMap = technics[moveType] || []

            return [
                <Fragment key='ngg_arena_ui_tech'>
                    {(phase === 'ui') && <div className='ngg_arena_ui_technics' style={{ width: uiTechWidth, height: uiTechHeight }}>
                        {techToMap.map((key, index) =>
                            <div className='ngg_arena_ui_card'
                                style={{ width: uiCardWidth, height: uiCardHeight }}
                                onClick={() => { this.onUiClickHandler({ point: TECHNICS[key].point, type: TECHNICS[key].type, technics: key }, index) }}>
                                <p>
                                    {key}
                                </p>
                            </div>)}
                    </div>}
                </Fragment>,
                <Fragment>
                    <NgGameRPGArenaUiExtras
                        key={123}
                        extrasInner={this.extrasInner}
                        setPlayerBuff={this.setPlayerBuff}
                        ref={this.refExtras}
                        left={0}
                        top={arenaHeight * 0.7}
                        zIndex={10}
                        arena={{ arenaWidth, arenaHeight }}
                        disabled={phase !== 'ui'}
                    />

                </Fragment>
            ]
        }

        return null;

    }

}